<template>
	<v-dialog  
	 	v-model="dialog"
	 	:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		:max-width="maxWidth"
		persistent
		@keydown.ctrl.l="log=!log"
	>
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar>
				<v-avatar>
					<v-icon :icon="icon"></v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>

				<v-spacer></v-spacer>

				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltip, attrs }">
						<v-btn icon v-bind="attrs" v-on="tooltip" color="#F40F02" @click="onPDF">
							<v-icon>mdi-file-pdf-box</v-icon>
						</v-btn>
					</template>
					<span>Інформація про страхового посередника</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltip, attrs }">
						<v-btn icon v-bind="attrs" v-on="tooltip" color="#1D6F42" @click="onExcel">
							<v-icon>mdi-microsoft-excel</v-icon>
						</v-btn>
					</template>
					<span>Зберегти Excel</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltip, attrs }">
						<v-btn icon v-bind="attrs" v-on="tooltip" @click="onJson">
							<v-icon>mdi-code-json</v-icon>
						</v-btn>
					</template>
					<span>Зберегти JSON</span>
				</v-tooltip>

				<v-divider vertical inset></v-divider>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-container>
					<v-expansion-panels
						v-model="panel"
						multiple
					>
						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Вид особи</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-col cols="12" md="6">
										<v-select
											v-model="mainData.imFt"
											:items="NbuFinTp"
											label="Вид агента/брокера"
											item-value="id"
											item-text="name"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-select>
									</v-col>
									<v-col cols="12" md="6">
										<v-select
											v-model="mainData.imSt"
											:items="NbuCompanyStatus"
											label="Стан"
											item-value="id"
											item-text="name"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-select>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="mainData.pib"
											label="ПІБ"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-data-table
											:items="insurAgentInSkInfo"
											:headers="headers.kindPersons"
											item-key="id"
											hide-default-footer
											disable-pagination
										>
											<template v-slot:item.iasStatus="{ item, index }">
												<span>{{ NbuCompanyStatus.find(element => element.id === item.iasStatus).name }}</span>
											</template>
											<template v-slot:item.iasStartDt="{ item, index }">
												<span>{{ item.iasStartDt | formatDate }}</span>
											</template>
											<template v-slot:item.iasEndDt="{ item, index }">
												<span>{{ item.iasEndDt | formatDate }}</span>
											</template>
											<template v-slot:item.actions="{ item, index }">
												<v-icon icon="mdi-close" color="medium-emphasis" size="small" @click="remove(menus, item)"></v-icon>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Тип особи</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-col cols="12" md="6">
										<v-select
											v-model="mainData.imCat"
											:items="NbuInsurCat"
											label="Тип особи"
											item-value="id"
											item-text="name"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-select>
									</v-col>
									<v-col cols="12" md="6">
										<v-select
											v-model="mainData.ianIsRfu"
											:items="NbuBool"
											label="Чи є посередник фінансовою установою"
											item-value="id"
											item-text="name"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-select>
									</v-col>
									<v-col cols="12">
										<v-data-table
											:items="insurAgentInSkInfo"
											:headers="headers.typePersons"
											item-key="id"
											hide-default-footer
											disable-pagination
										>
											<template v-slot:item.skIcrDate="{ item, index }">
												<span>{{ item.skIcrDate | formatDate }}</span>
											</template>
											<template v-slot:item.skCancelDate="{ item, index }">
												<span>{{ item.skCancelDate | formatDate }}</span>
											</template>
											<template v-slot:item.iasStatus="{ item, index }">
												<span>{{ NbuCompanyStatus.find(element => element.id === item.iasStatus).name }}</span>
											</template>
											<template v-slot:item.actions="{ item, index }">
												<v-icon icon="mdi-close" color="medium-emphasis" size="small" @click="remove(menus, item)"></v-icon>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Реєстраційні дані</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="mainData.icrRegNum"
											label="Реєстраційний номер в реєстрі посередників"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<VDateInput
											v-model="mainData.ihUserCreateDt"
											label="Дата внесення запису про страхового посередника до Реєстру посередників"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></VDateInput>
									</v-col>
									<v-col cols="12">
										<v-text-field
											v-model="mainData.iabReasonStopIds"
											label="Підстава виключення запису про страхового посередника з Реєстру посередників"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<VDateInput
											v-model="mainData.iabRoStopDt"
											label="Дата виключення запису про страхового посередника з Реєстру посередників"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></VDateInput>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="mainData.iabIsBadReputation"
											label="Втрата бездоганної ділової репутації (при виключені з Реєстру посередників)"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
						
						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Місцезнаходження</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="addres.indObl"
											label="Область"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="addres.indRegion"
											label="Район (в межах області)"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="addres.indCity"
											label="Населений пункт (тип та назва)"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Страхові та перестрахові продукти</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-data-table
									:items="insurProducts"
									:headers="headers.insurProducts"
									item-key="id"
								>
									<template v-slot:item.ipStartDt="{ item, index }">
										<span>{{ item.ipStartDt | formatDate }}</span>
									</template>
									<template v-slot:item.ipEndDt="{ item, index }">
										<span>{{ item.ipEndDt | formatDate }}</span>
									</template>
									<template v-slot:item.iasStatus="{ item, index }">
										<span>{{ NbuFinserviceTp.find(element => element.id === item.iasStatus).name }}</span>
									</template>
									<template v-slot:item.classes="{ item, index }">
										<span>{{ getProductСlasses(item.classes) }}</span>
									</template>
									<template v-slot:item.actions="{ item, index }">
										<v-icon icon="mdi-close" color="medium-emphasis" size="small"></v-icon>
									</template>
								</v-data-table>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Договір страхування відповідальності/поліс професійної відповідальності</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="liabilityInsurContract.licTp"
											label="Відмітка договір/поліс"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<VDateInput
											v-model="liabilityInsurContract.licDate"
											label="Дата укладання"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></VDateInput>
									</v-col>
									<v-col cols="12" md="6">
										<VDateInput
											v-model="liabilityInsurContract.licStartDt"
											label="Дата початку дії"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></VDateInput>
									</v-col>
									<v-col cols="12" md="6">
										<VDateInput
											v-model="liabilityInsurContract.licEndDt"
											label="Дата закінчення дії"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></VDateInput>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="liabilityInsurContract.licInsurNumident"
											label="Код ЄДРПОУ страховика, з яким укладено договір страхування відповідальності посередника/Номер реєстрації страховика-нерезидента в реєстрі уповноваженого органу в країні його реєстрації"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="liabilityInsurContract.licInsurName"
											label="Найменування страховика, з яким укладено такий договір/Найменування страховика-нерезидента в реєстрі уповноваженого органу в країні його реєстрації"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
									<v-col cols="12" md="6">
										<v-text-field
											v-model="liabilityInsurContract.licCn"
											label="Країна, в якій оформлено поліс"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Інформація про істотну участь страхового посередника в будь-якому страховику</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-data-table
										:items="insurInfluenceInfos"
										:headers="headers.insurInfluenceInfos"
										item-key="id"
										hide-default-footer
										disable-pagination
									>
										<template v-slot:item.actions="{ item, index }">
											<v-icon icon="mdi-close" color="medium-emphasis" size="small"></v-icon>
										</template>
									</v-data-table>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Інформація про істотну участь будь-якого страховика в страховому посереднику</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-data-table
									:items="insurParticipations"
									:headers="headers.insurParticipations"
									item-key="id"
									hide-default-footer
									disable-pagination
								>
									<template v-slot:item.actions="{ item, index }">
										<v-icon icon="mdi-close" color="medium-emphasis" size="small"></v-icon>
									</template>
								</v-data-table>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Керівники</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-data-table
									:items="managers"
									:headers="headers.managers"
									item-key="id"
									hide-default-footer
									disable-pagination
								>
									<template v-slot:item.ikStudyConfirmDt="{ item, index }">
										<span>{{ item.ikStudyConfirmDt | formatDate }}</span>
									</template>
									<template v-slot:item.ikTp="{ item, index }">
										<span>{{ NbuContactTp.find(element => element.id === item.ikTp).name }}</span>
									</template>
									<template v-slot:item.actions="{ item, index }">
										<v-icon icon="mdi-close" color="medium-emphasis" size="small"></v-icon>
									</template>
								</v-data-table>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Заходи впливу</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Контактна інформація про посередника</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="addres.iaWebsite"
											label="Вебсайт (вебсторінка)"
											outlined
											hide-details="auto"
											:readonly="readonly"
										></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel>
							<v-expansion-panel-header class="font-weight-bold">Контактна особа посередника</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-data-table
									:items="agentContacts"
									:headers="headers.agentContacts"
									item-key="id"
									hide-default-footer
									disable-pagination
								>
									<template v-slot:item.ikTp="{ item, index }">
										<span>{{ NbuContactTp.find(element => element.id === item.ikTp).name }}</span>
									</template>
									<template v-slot:item.actions="{ item, index }">
										<v-icon icon="mdi-close" color="medium-emphasis" size="small"></v-icon>
									</template>
								</v-data-table>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-container>
			</v-card-text>

			<v-card-actions v-if="!readonly">
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-overlay v-model="loading" contained class="align-center justify-center">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<z-pdf ref="pdf" :item="item"></z-pdf>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import mixin from './mixin/main'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
//import { VDateInput } from 'vuetify/labs/VDateInput'
import VDateInput from '@/views/components/control/Date'
import zPdf from '@/views/pdf/NbuInsuranceIntermediary'

export default {
	name: 'DialogDetailNbuInsuranceIntermediary',
	mixins: [mixin],
	components: { VDateInput, zPdf },
	data: () => ({
		title: 'Страховий посередник',
		icon: 'mdi-leaf',
		item: {},
		panel: [0,1,2,3,4,5,6,7,8,9,10,11],
		fullscreen: true,
	}),

	computed: {
		...mapGetters('NbuFinTp', { NbuFinTp: 'items' }),
		...mapGetters('NbuCompanyStatus', { NbuCompanyStatus: 'items' }),
		...mapGetters('NbuInsurCat', { NbuInsurCat: 'items' }),
		...mapGetters('NbuBool', { NbuBool: 'items' }),
		...mapGetters('NbuContactTp', { NbuContactTp: 'items' }),
		...mapGetters('NbuFinserviceTp', { NbuFinserviceTp: 'items' }),

		headers() {
			return {
				agentContacts: [
					{ value: 'pib', text: 'ПІБ',  sortable: true },//": "Гвоздьов Михайло Олексійович",
					{ value: 'ikPhone', text: 'Номер телефону',  sortable: true },//": null,
					{ value: 'ikEmail', text: 'Адреса електронної пошти',  sortable: true },//": null,
					{ value: 'ikTp', text: 'Вид особи, яка здійснює діяльність з надання посередницьких послуг',  sortable: true },//": "S",
					{ value: 'ianFullName', text: 'СК, якою внесено інформацію про контактну особу',  sortable: true },//": "ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО \"СТРАХОВА КОМПАНІЯ \"ПЗУ УКРАЇНА\""

					/* { value: 'ikId', text: '',  sortable: true },//": 1043573,
					{ value: 'ikNpt', text: '',  sortable: true },//": 2801,
					{ value: 'ikPrizv', text: '',  sortable: true },//": "Гвоздьов",
					{ value: 'ikName', text: '',  sortable: true },//": "Михайло",
					{ value: 'ikBatko', text: '',  sortable: true },//": "Олексійович",
					{ value: 'ikBuhNumident', text: '',  sortable: true },//": null,
					{ value: 'ikPt', text: '',  sortable: true },//": null,
					{ value: 'ikNumident', text: '',  sortable: true },//": null,
					{ value: 'ikPassport', text: '',  sortable: true },//": null,
					{ value: 'ikSetDt', text: '',  sortable: true },//": null,
					{ value: 'ikFreeDt', text: '',  sortable: true },//": null,
					{ value: 'ikDdt', text: '',  sortable: true },//": null,
					{ value: 'ikDiplomNo', text: '',  sortable: true },//": null,
					{ value: 'ikStudyManager', text: '',  sortable: true },//": null,
					{ value: 'ikStudyFinNumident', text: '',  sortable: true },//": null,
					{ value: 'ikStudyConfirmDt', text: '',  sortable: true },//": null,
					{ value: 'ikDiplomStartDt', text: '',  sortable: true },//": null,
					{ value: 'ikDiplomTermin', text: '',  sortable: true },//": null,
					{ value: 'ikDiplomStopDt', text: '',  sortable: true },//": null,
					{ value: 'ikNtt', text: '',  sortable: true },//": null,
					{ value: 'ikNote', text: '',  sortable: true },//": null,
					{ value: 'imId', text: '',  sortable: true },//": 20000035381,
					{ value: 'ihId', text: '',  sortable: true },//": 30000001143888,
					{ value: 'imNumIdent', text: '',  sortable: true },//": "20782312",
					{ value: 'imSt', text: '',  sortable: true },//": "A", */
					
				],
				contacts: [
					{ value: "ikId", text: '',  sortable: true },//: 1043573,
					{ value: "ikNpt", text: '',  sortable: true },//: 2801,
					{ value: "ikPrizv", text: 'Прізвище',  sortable: true },//: "Гвоздьов",
					{ value: "ikName", text: 'Ім’я',  sortable: true },//: "Михайло",
					{ value: "ikBatko", text: 'По батькові (за наявності)',  sortable: true },//: "Олексійович",
					{ value: "ikBuhNumident", text: '',  sortable: true },//: null,
					{ value: "ikTp", text: 'Тип керівника',  sortable: true },//: "S",
					{ value: "ikPhone", text: '',  sortable: true },//: null,
					{ value: "ikEmail", text: '',  sortable: true },//: null,
					{ value: "ikPt", text: '',  sortable: true },//: null,
					{ value: "ikNumident", text: '',  sortable: true },//: null,
					{ value: "ikPassport", text: '',  sortable: true },//: null,
					{ value: "ikSetDt", text: '',  sortable: true },//: null,
					{ value: "ikFreeDt", text: 'Дата закінчення дії',  sortable: true },//: null,
					{ value: "ikDdt", text: '',  sortable: true },//: null,
					{ value: "ikDiplomNo", text: '',  sortable: true },//: null,
					{ value: "ikStudyManager", text: 'Повне найменування особи, яка провела навчання',  sortable: true },//: null,
					{ value: "ikStudyFinNumident", text: '',  sortable: true },//: null,
					{ value: "ikStudyConfirmDt", text: 'Дата підтвердження рівня знань (підвищення кваліфікації, дата видачі документу)',  sortable: true },//: null,
					{ value: "ikDiplomStartDt", text: '',  sortable: true },//: null,
					{ value: "ikDiplomTermin", text: 'Тривалість навчання (в годинах)',  sortable: true },//: null,
					{ value: "ikDiplomStopDt", text: '',  sortable: true },//: null,
					{ value: "ikNtt", text: '',  sortable: true },//: null,
					{ value: "pib", text: '',  sortable: true },//: "Гвоздьов Михайло Олексійович",
					{ value: "ikNote", text: '',  sortable: true },//: null,
					{ value: "imId", text: '',  sortable: true },//: null,
					{ value: "ihId", text: '',  sortable: true },//: null,
					{ value: "imNumIdent", text: '',  sortable: true },//: null,
					{ value: "imSt", text: '',  sortable: true },//: null,
					{ value: "ianFullName", text: '',  sortable: true },//: null
				],
				managers: [

					//{ value: "ikId", text: '',  sortable: true },//: 1043573,
					//{ value: "ikNpt", text: '',  sortable: true },//: 2801,
					{ value: "ikTp", text: 'Тип керівника',  sortable: true },//: "S",
					{ value: "ikPrizv", text: 'Прізвище',  sortable: true },//: "Гвоздьов",
					{ value: "ikName", text: 'Ім’я',  sortable: true },//: "Михайло",
					{ value: "ikBatko", text: 'По батькові (за наявності)',  sortable: true },//: "Олексійович",
					//{ value: "ikBuhNumident", text: '',  sortable: true },//: null,
					
					//{ value: "ikPhone", text: '',  sortable: true },//: null,
					//{ value: "ikEmail", text: '',  sortable: true },//: null,
					//{ value: "ikPt", text: '',  sortable: true },//: null,
					//{ value: "ikNumident", text: '',  sortable: true },//: null,
					//{ value: "ikPassport", text: '',  sortable: true },//: null,
					//{ value: "ikSetDt", text: '',  sortable: true },//: null,
					{ value: "ikStudyManager", text: 'Повне найменування особи, яка провела навчання',  sortable: true },//: null,
					//{ value: "ikDiplomNo", text: '',  sortable: true },//: null,
					//{ value: "ikStudyFinNumident", text: '',  sortable: true },//: null,
					{ value: "ikStudyConfirmDt", text: 'Дата підтвердження рівня знань (підвищення кваліфікації, дата видачі документу)',  sortable: true },//: null,
					//{ value: "ikDiplomStartDt", text: '',  sortable: true },//: null,
					{ value: "ikDiplomTermin", text: 'Тривалість навчання (в годинах)',  sortable: true },//: null,
					//{ value: "ikDiplomStopDt", text: '',  sortable: true },//: null,
					{ value: "ikFreeDt", text: 'Дата закінчення дії',  sortable: true },//: null,
					//{ value: "ikDdt", text: '',  sortable: true },//: null,
					//{ value: "ikNtt", text: '',  sortable: true },//: null,
					//{ value: "pib", text: '',  sortable: true },//: "Гвоздьов Михайло Олексійович",
					//{ value: "ikNote", text: '',  sortable: true },//: null,
					//{ value: "imId", text: '',  sortable: true },//: null,
					//{ value: "ihId", text: '',  sortable: true },//: null,
					//{ value: "imNumIdent", text: '',  sortable: true },//: null,
					//{ value: "imSt", text: '',  sortable: true },//: null,
					//{ value: "ianFullName", text: '',  sortable: true },//: null
				],

				finServices: [],

				kindPersons: [
					{ value: "iasTpName", text: 'Вид особи, яка здійснює діяльність з надання посередницьких послуг',  sortable: true },//: "Страховий агент",
					{ value: "iasStartDt", text: 'Дата початку дії виду особи',  sortable: true },//: "2025-03-12T00:00:00",
					{ value: "iasEndDt", text: 'Дата закінчення дії виду особи',  sortable: true },//: null,
					{ value: "skNumident", text: 'Код ЄДРПОУ страховика',  sortable: true },//: "20474912",
					{ value: "skShortName", text: 'Скорочене найменування страховика',  sortable: true },//: "АТ \"СК \"АРКС\"",
					{ value: "iabReasonStopIds", text: 'Підстава скасування співпраці',  sortable: true },//: null,

				],
				typePersons: [
					{ value: "skNumident", text: 'Код ЄДРПОУ страховика',  sortable: true },//: "20474912",
					{ value: "skFullName", text: 'Повне найменування страховика',  sortable: true },//: "Приватне акціонерне товариство \"Страхова компанія \"АРКС\"",
					{ value: "iasStatus", text: 'Стан з ДРФУ',  sortable: true },//: "A",
					{ value: "skIcrDate", text: 'Дата включення до ДРФУ',  sortable: true },//: "2004-08-21T00:00:00",
					{ value: "skCancelDate", text: 'Дата виключення з ДРФУ',  sortable: true },//: null,
					{ value: "adminName", text: 'Головний страховик агента',  sortable: true },//: "Приватне акціонерне товариство \"Страхова компанія \"АРКС\"",
					{ value: "adminNumident", text: 'Код ЄДРПОУ страхового агента (за наявності)',  sortable: true },//: "20474912",
					{ value: "iabReasonStopIds", text: 'Підстава скасування співпраці',  sortable: true },//: null,
				],

				insurAgentInSkInfo: [
					{ value: "skNumident", text: 'Код ЄДРПОУ страховика',  sortable: true },//: "20474912",
					{ value: "skFullName", text: 'Повне найменування страховика',  sortable: true },//: "Приватне акціонерне товариство \"Страхова компанія \"АРКС\"",
					//{ value: "skShortName", text: 'Скорочене найменування страховика',  sortable: true },//: "АТ \"СК \"АРКС\"",
					{ value: "iasStatus", text: '',  sortable: true },//: "A",
					{ value: "skIcrDate", text: 'Дата включення до ДРФУ',  sortable: true },//: "2004-08-21T00:00:00",
					{ value: "skCancelDate", text: 'Дата виключення з ДРФУ',  sortable: true },//: null,
					{ value: "adminName", text: 'Головний страховик агента',  sortable: true },//: "Приватне акціонерне товариство \"Страхова компанія \"АРКС\"",
					{ value: "adminNumident", text: 'Код ЄДРПОУ страхового агента (за наявності)',  sortable: true },//: "20474912",
					{ value: "iabReasonStopIds", text: 'Підстава скасування співпраці',  sortable: true },//: null,

					//{ value: "iasId", text: '',  sortable: true },//: 95117,
					//{ value: "iasImAgent", text: '',  sortable: true },//: 30000001022679,
					//{ value: "iasImSk", text: '',  sortable: true },//: 20000032403,
					//{ value: "iasIh", text: '',  sortable: true },//: 30000001143888,
					
					//{ value: "iasTp", text: '',  sortable: true },//: "A",
					//{ value: "iasStartDt", text: 'Дата початку дії виду особи',  sortable: true },//: "2025-03-12T00:00:00",
					//{ value: "iasEndDt", text: 'Дата закінчення дії виду особи',  sortable: true },//: null,
					/* { value: "iasImMainAgent", text: '',  sortable: true },//: null,
					{ value: "iasDelFlag", text: '',  sortable: true },//: false,
					{ value: "agNumident", text: '',  sortable: true },//: "2698515353",
					{ value: "agGuid", text: '',  sortable: true },//: "NQXMZ2491539629",
					{ value: "agFullName", text: '',  sortable: true },//: "Гвоздьов",
					{ value: "agShortName", text: '',  sortable: true },//: "Михайло",
					{ value: "agOtherName", text: '',  sortable: true },//: "Олексійович",
					{ value: "agPassport", text: '',  sortable: true },//: null,
					{ value: "agImSt", text: '',  sortable: true },//: "A",
					{ value: "agImCat", text: '',  sortable: true },//: "P",
					{ value: "agRegNum", text: '',  sortable: true },//: "00004338",
					{ value: "agStartDate", text: '',  sortable: true },//: "2025-03-21T00:00:00",
					{ value: "agEndDate", text: '',  sortable: true },//: null,
					
					{ value: "skImSt", text: '',  sortable: true },//: "A",
					{ value: "skRegNum", text: '',  sortable: true },//: "11100795",
					{ value: "skStartDate", text: '',  sortable: true },//: "2019-07-11T00:00:00",
					{ value: "skEndDate", text: '',  sortable: true },//: null,
					{ value: "mainNumident", text: '',  sortable: true },//: null,
					{ value: "mainGuid", text: '',  sortable: true },//: null,
					{ value: "mainFullName", text: '',  sortable: true },//: null,
					{ value: "mainShortName", text: '',  sortable: true },//: null,
					{ value: "mainOtherName", text: '',  sortable: true },//: null,
					{ value: "mainPassport", text: '',  sortable: true },//: null,
					{ value: "mainImSt", text: '',  sortable: true },//: null,
					{ value: "mainImCat", text: '',  sortable: true },//: null,
					{ value: "mainRegNum", text: '',  sortable: true },//: null,
					{ value: "mainStartDate", text: '',  sortable: true },//: null,
					{ value: "mainEndDate", text: '',  sortable: true },//: null,
					{ value: "ihImAdmin", text: '',  sortable: true },//: 20000032403,
					{ value: "ihImEditor", text: '',  sortable: true },//: 0,
					{ value: "editorNumident", text: '',  sortable: true },//: null,
					{ value: "editorName", text: '',  sortable: true },//: null,
					{ value: "canSendRequest", text: '',  sortable: true },//: false,
					{ value: "agImCatName", text: '',  sortable: true },//: "Фізична особа-підприємець", */
					//{ value: "iasTpName", text: 'Вид особи, яка здійснює діяльність з надання посередницьких послуг',  sortable: true },//: "Страховий агент",
					//{ value: "agImStName", text: '',  sortable: true },//: "Зареєстровано",
					
					//{ value: "iasIasMain", text: '',  sortable: true },//: 465,
					
					//{ value: "iasComment", text: '',  sortable: true },//: null,
					//{ value: "delIhRsn", text: '',  sortable: true },//: null,
					//{ value: "delIhCrsn", text: '',  sortable: true },//: null */
				],

				insurInfluenceInfos: [],
				insurParticipations: [],
				insurProducts: [
					//{ value: "ipId", text: '',  sortable: true },//: 252017,
					//{ value: "ipIp", text: '',  sortable: true },//: null,
					{ value: "ipName", text: 'Найменування страхового та/або перестрахового продукту за класами страхування',  sortable: true },//: "Страхування відповідальності власників наземних транспортних засобів за внутрішніми договорами ОСЦПВ (Автоцивілка)",
					{ value: "classes", text: 'Клас (класи) страхування або ризики в межах класу (класів) страхування',  sortable: true },//: [ 20001000185 ]
					{ value: "ipStartDt", text: 'Дата початку дії продукту (відповідно до ліцензії страховика в ДРФУ)',  sortable: true },//: "2022-01-01T00:00:00",
					{ value: "ipEndDt", text: 'Дата закінчення дії продукту (відповідно до ліцензії страховика в ДРФУ)',  sortable: true },//: null,
					//{ value: "ipCat", text: '',  sortable: true },//: "P",
					{ value: "ipInsurName", text: 'Повне найменування страховика',  sortable: true },//: "Приватне акціонерне товариство \"Страхова компанія \"АРКС\"",
					{ value: "ipInsurNumident", text: 'Код ЄДРПОУ страховика',  sortable: true },//: "20474912",
					
				],
				licences: [],
				typeActRelSaleProds: [
					{ value: "tarspId", text: '',  sortable: true },//: 39542,
					{ value: "tarspTarsp", text: '',  sortable: true },//: null,
					{ value: "tarspLasi", text: '',  sortable: true },//: 1001,
					{ value: "tarspStartDt", text: '',  sortable: true },//: "2022-01-01T00:00:00",
					{ value: "tarspEndDt", text: '',  sortable: true },//: null
				],
			}
		},

		mainData() {
			return this.item?.mainData ? this.item.mainData : {}
		},
		addres() {
			return this.item?.addres ? this.item.addres : {}
		},
		liabilityInsurContract() {
			return this.item?.liabilityInsurContract ? this.item.liabilityInsurContract : {}
		},

		agentContacts() {
			return this.item?.agentContacts ? this.item.agentContacts : (this.item?.agentContacts ? this.item.agentContacts : [])
		},
		contacts() {
			return this.item?.contacts ? this.item.contacts : []
		},
		finServices() {
			return this.item?.finServices ? this.item.finServices : []
		},
		insurAgentInSkInfo() {
			return this.item?.insurAgentInSkInfo ? this.item.insurAgentInSkInfo : []
		},
		insurInfluenceInfos() {
			return this.item?.insurInfluenceInfos ? this.item.insurInfluenceInfos : []
		},
		insurParticipations() {
			return this.item?.insurParticipations ? this.item.insurParticipations : []
		},
		insurProducts() {
			return this.item?.insurProducts ? this.item.insurProducts : []
		},
		licences() {
			return this.item?.licences ? this.item.licences : []
		},
		typeActRelSaleProds() {
			return this.item?.typeActRelSaleProds ? this.item.typeActRelSaleProds : []
		},

		managers() {
			return this.item?.contacts ? this.item.contacts.filter(el => el.ikTp === 'S') : []
		},
	},

	methods: {
		//...mapActions('Role', ['find', 'create', 'update', 'setItem']),

		onClear() {
			this.item = {}
		},

		onOpen () {
			//console.log(this.$options.name, 'onOpen','selected', this.selected)
			//console.log(this.$options.name, 'onOpen', 'user', this.user)
			this.onClear()

			if(this.data) {
				this.item = { ...this.data }
			} else if(this.selected) {
				this.loading = true
				this.find(this.selected.imId).finally(() => { this.loading = false });
			}
		},

		find(id) {
			var that = this
			return axios.get(`/nbu/kis/PublicInfo/InsurMainCard/${id}`).then(response => {
				console.log(that.$options.name, 'find','response.data', response.data)

				that.item = response.data
			}, error => {
				console.log('error', error)
				this.showMessage(error)
			})
		},

		getNbuContactTp(id) {
			return this.NbuContactTp.find(element => element.id === id).name
		},

		getProductСlasses(classes) {
			//console.log(this.$options.name,  'getProductСlasses', 'classes', classes)

			//let types = this.NbuFinserviceTp;
			//console.log(this.$options.name,  'getProductСlasses', 'types', types)

			let names = []
			if (Array.isArray(classes)) {
				classes.forEach((item) => {
					const type = this.NbuFinserviceTp.find(element => String(element.id) === String(item))
					if(type?.name) {
						names.push(type.name)
					}
				})
			}

			return names.join(", ");
		},

		onExcel() {
			//console.log(this.$options.name,  'onExcel', 'item', this.item)
			
			const filename = `${this.title}.xlsx`

			const workbook = XLSX.utils.book_new();

			//const worksheet = XLSX.utils.json_to_sheet(this.agentContacts);
			//XLSX.utils.book_append_sheet(workbook, worksheet, 'agentContacts');

			const worksheet1 = XLSX.utils.json_to_sheet(this.agentContacts);
			XLSX.utils.book_append_sheet(workbook, worksheet1, 'agentContacts');

			const worksheet2 = XLSX.utils.json_to_sheet(this.contacts);
			XLSX.utils.book_append_sheet(workbook, worksheet2, 'contacts');

			const worksheet3 = XLSX.utils.json_to_sheet(this.finServices);
			XLSX.utils.book_append_sheet(workbook, worksheet3, 'finServices');

			const worksheet4 = XLSX.utils.json_to_sheet(this.insurAgentInSkInfo);
			XLSX.utils.book_append_sheet(workbook, worksheet4, 'insurAgentInSkInfo');

			const worksheet5 = XLSX.utils.json_to_sheet(this.insurInfluenceInfos);
			XLSX.utils.book_append_sheet(workbook, worksheet5, 'insurInfluenceInfos');

			const worksheet6 = XLSX.utils.json_to_sheet(this.insurParticipations);
			XLSX.utils.book_append_sheet(workbook, worksheet6, 'insurParticipations');

			const worksheet7 = XLSX.utils.json_to_sheet(this.insurProducts);
			XLSX.utils.book_append_sheet(workbook, worksheet7, 'insurProducts');

			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
			const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
			saveAs(blob,  filename);
		},

		onJson() {
			const filename = `${this.title}.json`
			const text = JSON.stringify(this.item, null, 2);

			const blob = new Blob([text], { type: 'text/plain' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;

			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		},

		onPDF () {
			console.log(this.$options.name,  'onPDF', 'item', this.item)

			this.$refs.pdf.generate()
		},
	},
}
</script>